import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography, Avatar, Skeleton, Tooltip } from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import Iconify from '../../../../components/Iconify';
import { db } from '../../../../firebase.config';
import { UserAuth } from '../../../../context/AuthContext';


const LinkedAccounts = () => {
  const { user, userData } = UserAuth();
  const [loading, setLoading] = useState(true);
  const [accounts, setAccounts] = useState({});

  const services = [
    {
      name: 'Facebook',
      icon: 'logos:facebook',
      color: '#1877f2',
      key: 'facebook',
    },
    {
      name: 'TikTok',
      icon: 'logos:tiktok-icon',
      color: '#000000',
      key: 'tiktok',
    }
  ];

  const fetchLinkedAccounts = async () => {
    try {
      if (!user?.uid) return;
      setLoading(true);
        console.log(userData)
      const docSnap = await getDoc(doc(db, 'organisateurs', user.uid));
      if (docSnap.exists()) {
        const data = docSnap.data();
        setAccounts(data.accounts || {});
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des comptes liés:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLinkedAccounts();
  }, [user, userData]);

  return (
    <Box sx={{ padding: 2, width: '100%' }}>
      <Stack spacing={2}>
        <Typography variant="subtitle1">Comptes associés</Typography>
        {loading ? (
          <Stack direction="row" spacing={2}>
            {services.map((_, index) => (
              <Skeleton key={index} variant="circular" width={35} height={35} />
            ))}
          </Stack>
        ) : (
          <Stack direction="row" spacing={2} alignItems="center">
            {services.map((service) => {
              const isLinked = accounts[service.key] === true;

              return (
                <Tooltip
                  key={service.key}
                  title={isLinked ? `${service.name} connecté` : `${service.name} non connecté`}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Avatar sx={{ width: 35, height: 35, bgcolor: service.color }}>
                      <Iconify icon={service.icon} sx={{ width: 24, height: 24 }} />
                    </Avatar>
                    <Box display="flex" alignItems="flex-end">
                      <Iconify
                        icon={isLinked ? 'mdi:link' : 'material-symbols-light:link-off'}
                        sx={{
                          width: 20,
                          height: 20,
                          color: isLinked ? 'green' : 'red',
                        }}
                      />
                    </Box>
                  </Stack>
                </Tooltip>
              );
            })}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default LinkedAccounts;
